import { Input } from "antd";
import PropTypes from "prop-types";
import { useState } from "react";

const CInput = (props) => {
  const { allowWhiteSpace = true, value, onChange, ...rest } = props;
  const [val, setVal] = useState(value);

  return (
    <Input
      {...rest}
      value={val}
      onChange={(e) => {
        if (!allowWhiteSpace) {
          const newVal = e.target.value.split(" ").join("");
          setVal(newVal);
        } else {
          setVal(e.target.value);
        }
        if (onChange && typeof onChange === "function") {
          onChange(e);
        }
      }}
    />
  );
};
CInput.propTypes = {
  allowWhiteSpace: PropTypes.bool,
};
export default CInput;
